export class VerificarPermissoes {
    public static temPermissao(permissoes: string[], permissoesDoUsuario: any): boolean{
        for (let permissao of permissoes){
            if(permissoesDoUsuario.includes(permissao)){
                return true
            }
        }
        return false;
    }
}